<template>
  <div v-if="loading">
    <Loader />
  </div>
  <div class="card" v-if="!loading">
    <div class="card-header">
      <h3 class="card-title" style="font-size: 20px; font-weight: bold">
        {{ $t("salessummarycashvan") }}
      </h3>
      <div class="card-toolbar">
        <!-- <button
          type="button"
          class="btn btn-sm btn-light btn-success btn-hover-scale me-2"
          style="font-size: 14px; font-weight: bold"
          @click="gotoImportExcel()"
        >
          นำข้อมูลเข้าจาก Excel
        </button> -->
        <!-- <button
          type="button"
          class="btn btn-sm btn-light btn-primary"
          style="font-size: 14px; font-weight: bold"
          @click="goToNew()"
        >
          + เพิ่มใบขายส่ง
        </button> -->
      </div>
    </div>
    <div class="card-title row ms-5 me-5 mt-6">
      <!-- <div class="col-sm-2 mb-3">
        <a-date-picker
          class="form-control ant-date"
          :locale="locale"
          v-model:value="date"
          format="DD/MM/YYYY"
          inputReadOnly
        />
      </div> -->
      <div class="col-sm-10 mb-3">
        <!-- placeholder="ค้นหาจาก เลขที่เอกสาร / รหัสผู้ซื้อ /สาขา /เลขที่ van" -->
        <input
          v-model="searchInput"
          placeholder="ค้นหาจาก หมายเลขเอกสาร / Invoice Number"
          type="text"
          class="form-control"
        />
      </div>
      <div class="col-sm-3 mb-3">
        <select v-model="selectStatus" class="form-select">
          <option value="">--สถานะ ทั้งหมด--</option>
          <option value="ยกเลิก">ยกเลิก</option>
          <option value="รอดำเนินการ">รอดำเนินการ</option>
          <option value="ออกบิล">ออกบิล</option>
        </select>
      </div>
      <!-- <div class="col-sm-3 mb-3">
        <a-date-picker
          class="form-control ant-date"
          :locale="locale"
          v-model:value="date_from"
          format="DD/MM/YYYY"
          inputReadOnly
        />
      </div>
      <div class="col-sm-3 mb-3">
        <a-date-picker
          class="form-control ant-date"
          :locale="locale"
          v-model:value="date_to"
          format="DD/MM/YYYY"
          inputReadOnly
        />
      </div> -->
      <div class="col-sm-2">
        <!-- <label>เลือก van</label> -->
        <a-date-picker
          class="form-control ant-date"
          :locale="locale"
          v-model:value="dateSelected"
          format="DD/MM/YYYY"
          inputReadOnly
        />
      </div>
      <div class="col-sm-3">
        <select v-model="vanSelected" class="form-select">
          <option value="">--เลือก VAN ทั้งหมด--</option>
          <option :value="i" v-for="i in vans" :key="i">
            {{ i.van_code }} | {{ i.van_name }}
          </option>
        </select>
      </div>
      <div class="col-sm-3 text-start">
        <button
          @click="search()"
          type="button"
          class="btn btn-sm btn-light-primary"
          style="font-size: 14px; font-weight: bold"
        >
          {{ $t("search") }}
        </button>

        <button
          @click="clear()"
          type="button"
          class="btn btn-sm btn-light-danger ms-2"
          style="font-size: 14px; font-weight: bold"
        >
          {{ $t("clear") }}
        </button>
      </div>
    </div>
    <div class="card-title row ms-5 me-5 mt-0">
      <!-- <div class="col-sm-2" style="align-self: center">
        <a-date-picker
          class="form-control ant-date"
          :locale="locale"
          v-model:value="dateSelected"
          format="DD/MM/YYYY"
          inputReadOnly
        />
      </div>
      <div class="col-sm-3">
        <select v-model="vanSelected" class="form-select">
          <option value="">--เลือก VAN ทั้งหมด--</option>
          <option :value="i" v-for="i in vans" :key="i">
            {{ i.van_code }} | {{ i.van_name }}
          </option>
        </select>
      </div> -->
      <div class="col-sm-10 text-end">
        <button
          type="button"
          class="btn btn-sm btn-warning bi bi-truck me-2"
          @click="prepareItems()"
        >
          ดาวน์โหลดใบจัดของ
        </button>
        <!-- </div>
      <div class="col-sm-3"> -->
        <button
          type="button"
          class="btn btn-sm btn-primary bi bi-pdf me-2"
          @click="checkboxprint()"
        >
          ดาวน์โหลดหลายใบเสร็จ
        </button>
        <!-- </div>
      <div class="col-sm-3 text-end"> -->
        <vue3-json-excel
          :json-data="dataItemsShow"
          :fields="json_fields"
          type="xls"
          name="ข้อมูลสินค้า.xls"
        >
          <button
            class="btn btn-sm btn-light btn-success"
            style="font-size: 14px; font-weight: bold"
          >
            <span class="svg-icon svg-icon-2x dark">
              <inline-svg src="media/Excel.svg" />
              Download Excel
            </span>
          </button>
        </vue3-json-excel>
      </div>
    </div>

    <div class="card-body" style="padding-top: 3px; padding-bottom: 15px">
      <div class="table-responsive">
        <a-table
          :dataSource="dataItemsShow"
          :columns="columns"
          :scroll="{ x: 1300 }"
        >
          <template #headerCell="{ column }">
            <template v-if="column.dataIndex === 'point_of_sale_no'">
              {{ $t("documentnumber") }}
            </template>
            <template v-if="column.dataIndex === 'transaction_number'">
              {{ $t("transaction_number") }}
            </template>
            <template v-if="column.dataIndex === 'invoice_number'">
              Invoice Number
            </template>
            <template v-if="column.dataIndex === 'customer.code'">
              {{ $t("buyercode") }}
            </template>
            <template v-if="column.dataIndex === 'customer.name'">
              {{ $t("buyername") }}
            </template>
            <template v-if="column.dataIndex === 'createdAt'">
              {{ $t("date") }}
            </template>
            <template v-if="column.dataIndex === 'discount'">
              {{ $t("discouts") }}
            </template>
            <template v-if="column.dataIndex === 'payment_by'">
              {{ $t("payby") }}
            </template>
            <template v-if="column.dataIndex === 'total_price_summary'">
              {{ $t("net") }}
            </template>
            <template v-if="column.dataIndex === 'cash'">
              {{ $t("cash") }}
            </template>

            <template v-if="column.dataIndex === 'van'">
              {{ $t("van") }}
            </template>
            <template v-if="column.dataIndex === 'status'">
              {{ $t("status") }}
            </template>
            <template v-if="column.dataIndex === 'reprint'">
              {{ $t("reprint") }}
            </template>
          </template>

          <template #bodyCell="{ column, record, index }">
            <template v-if="column.dataIndex === 'checkbox'">
              <input type="checkbox" v-model="record.check" />
            </template>
            <template v-if="column.dataIndex === 'point_of_sale_no'">
              {{ record.no }}
            </template>
            <template v-if="column.dataIndex === 'transaction_number'">
              {{ record.transaction_number ? record.transaction_number : "" }}
            </template>
            <template v-if="column.dataIndex === 'invoice_number'">
              {{ record.invoice_number ? record.invoice_number : "" }}
            </template>
            <template v-if="column.dataIndex === 'customer.code'">
              <span v-if="record.customer.code">
                {{ record.customer.code ? record.customer.code : "" }}
              </span>
            </template>
            <template v-if="column.dataIndex === 'customer.name'">
              <span v-if="record.customer.name">
                {{ record.customer.name ? record.customer.name : "" }}
              </span>
            </template>
            <template v-if="column.dataIndex === 'createdAt'">
              <span v-if="record.createdAt">
                {{ record.createdAt ? convertDate(record.createdAt) : "" }}
              </span>
            </template>
            <template v-if="column.dataIndex === 'route'">
              <span v-if="record.route">
                {{ record.route ? record.route.code : "" }} |
                {{ record.route ? record.route.name : "" }}
              </span>
            </template>
            <template v-if="column.dataIndex === 'van'">
              <span v-if="record.van">
                {{ record.van ? record.van.van_code : "" }} |
                {{ record.van ? record.van.van_name : "" }}
              </span>
              <span v-else> - </span>
            </template>
            <template v-if="column.dataIndex === 'status'">
              <select
                class="form-select"
                v-model="record.status"
                @change="changeStatus(record)"
                :disabled="
                  record.status == 'ยกเลิก' || userAuth.isCanModified == false
                "
              >
                <!-- <option
                  value="Pre-order"
                  :disabled="
                    record.status == 'รอจัดส่ง' ||
                    record.status == 'จัดส่งสำเร็จ'
                  "
                >
                  Pre-order
                </option> -->
                <option value="ยกเลิก">ยกเลิก</option>
                <option
                  value="ชำระเงินแล้ว"
                  :disabled="record.status == 'ชำระเงินแล้ว'"
                >
                  ชำระเงินแล้ว
                </option>
                <!-- <option
                  value="คอนเฟิร์มออเดอร์"
                  :disabled="
                    record.status == 'รอจัดส่ง' ||
                    record.status == 'จัดส่งสำเร็จ' ||
                    record.status == 'ยกเลิก'
                  "
                >
                  คอนเฟิร์มออเดอร์
                </option>
                <option
                  value="รอจัดส่ง"
                  :disabled="
                    record.status == 'จัดส่งสำเร็จ' || record.status == 'ยกเลิก'
                  "
                >
                  รอจัดส่ง
                </option>
                <option
                  value="จัดส่งสำเร็จ"
                  :disabled="record.status == 'ยกเลิก'"
                >
                  จัดส่งสำเร็จ
                </option> -->
              </select>
            </template>
            <template v-if="column.dataIndex === 'reprint'">
              <div class="row">
                <div class="col-sm-3" v-if="userAuth.isCanModified">
                  <button
                    type="button"
                    class="btn btn-link btn-color-muted btn-active-color-success p-0"
                    @click="goToEdit(record.id)"
                  >
                    <i class="bi bi-eye"></i>
                  </button>
                </div>

                <div class="col-sm-3">
                  <button
                    type="button"
                    class="btn btn-link btn-color-muted btn-active-color-success me-sm-2 p-0"
                    @click="goToExportOrder(record, index)"
                  >
                    <i class="bi bi bi-files"></i>
                  </button>
                </div>
                <div class="col-sm-3">
                  <button
                    type="button"
                    class="btn btn-link btn-color-muted btn-active-color-success m-0 p-0"
                    @click="goToExportReceive(record, index)"
                  >
                    <i class="bi bi-printer-fill"></i>
                  </button>
                </div>

                <!-- <div class="col-sm-3">
                  <button
                    class="
                      btn btn-link btn-color-muted btn-active-color-danger
                      m-0
                      p-0
                    "
                    @click="handleCancelOrder(item)"
                    @mouseenter="handleHoverB()"
                    style="color: red; cursor: pointer"
                  >
                    <i class="bi bi-x-circle"></i>
                  </button>
                </div> -->
              </div>
            </template>
          </template>
        </a-table>

        <!-- <table
          class="table table-hover table-rounded table-striped border gy-7 gs-7"
        >
          <thead>
            <tr
              style="width: 100%"
              class="
                fw-bold
                fs-5
                text-gray-800
                border-bottom-2 border-gray-200
                mw-200px
              "
            >
              <th>{{ $t("documentnumber") }}</th>
              <th>{{ $t("buyercode") }}</th>
              <th>{{ $t("buyercode") }}</th>
              <th>VAN</th>
              <th>{{ $t("date") }}</th>
              <th>{{ $t("discouts") }}</th>
              <th>{{ $t("payby") }}</th>

              <th>{{ $t("net") }}</th>
              <th>{{ $t("cash") }}</th>
              <th>{{ $t("status") }}</th>
              <th style="text-align: center">{{ $t("reprint") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="dataItemsShow.length < 1">
              <td class="text-center" colspan="9">ไม่มีข้อมูล</td>
            </tr>
            <tr v-for="(item, index) in dataItemsShow" :key="index">
              <td>{{ item.point_of_sale_no ? item.point_of_sale_no : "" }}</td>
              <td>
                {{ item.customer ? item.customer.code : "" }}
              </td>
              <td>
                {{ item.customer.name }}
              </td>
              <td></td>
              <td>
                {{ setDateThLocale(item.createdAt) }}
              </td>
              <td style="text-align: right">
                {{ item.discount ? item.discount : 0 }} %
              </td>
              <td>{{ item.payment_by ? item.payment_by : "ไม่เข้า" }}</td>

              <td style="text-align: right">{{ item.total_price_summary }} ฿</td>
              <td style="text-align: right">{{ item.cash || 0 }} ฿</td>
              <td>
                <select
                  class="form-select"
                  v-model="item.status"
                  @change="changeStatus(item)"
                >
                  <option
                    value="Pre-order"
                    :disabled="
                      item.status == 'รอจัดส่ง' || item.status == 'จัดส่งสำเร็จ'
                    "
                  >
                    Pre-order
                  </option>
                  <option
                    value="คอนเฟิร์มออเดอร์"
                    :disabled="
                      item.status == 'รอจัดส่ง' || item.status == 'จัดส่งสำเร็จ'
                    "
                  >
                    คอนเฟิร์มออเดอร์
                  </option>
                  <option
                    value="รอจัดส่ง"
                    :disabled="item.status == 'จัดส่งสำเร็จ'"
                  >
                    รอจัดส่ง
                  </option>
                  <option value="จัดส่งสำเร็จ">จัดส่งสำเร็จ</option>
                </select>
              </td>
              <td>
                <div class="row">
                  <div class="col-sm-4">
                    <button
                      type="button"
                      class="
                        btn btn-link btn-color-muted btn-active-color-success
                        m-0
                        p-0
                      "
                      @click="goToEdit(item.id)"
                    >
                      <i class="bi bi-eye-fill"></i>
                    </button>
                  </div>
                  <div class="col-sm-4">
                    <button
                      type="button"
                      class="
                        btn btn-link btn-color-muted btn-active-color-success
                        m-0
                        p-0
                      "
                    >
                      <i class="bi bi-printer-fill"></i>
                    </button>
                  </div>

                  <div class="col-sm-4">
                    <button
                      class="
                        btn btn-link btn-color-muted btn-active-color-danger
                        m-0
                        p-0
                      "
                      @click="handleCancelOrder(item)"
                      @mouseenter="handleHoverB()"
                      style="color: red; cursor: pointer"
                    >
                      <i class="bi bi-x-circle"></i>
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table> -->
      </div>

      <h4 class="mt-3">
        {{ $t("total") }} : <b>{{ total }}</b> บาท
      </h4>
    </div>

    <div v-if="isExportOrder">
      <pdfOrder
        orderForm="Cash Van"
        :dataExport="dataExport"
        @generatedFile="generatedFile"
      />
    </div>
    <div v-if="isExportReceive">
      <pdfFile :dataExport="dataExport" @generatedFile="generatedFile" />
    </div>

    <!-- <DialogConfirmByPass
      :dialogConfirmByPass="dialogConfirmByPass"
      @submitConfirmPass="submitConfirmPass"
      @closeDialogConformByPass="closeDialogConformByPass"
    /> -->

    <DialogCancelOrder
      :dialogCancelOrder="dialogCancelOrder"
      @submitCancelOrder="submitCancelOrder"
      @closeDialogCancelOrder="closeDialogCancelOrder"
    />

    <!-- <div class="card-footer">
      <Pagination
        :items="tableItems"
        @filterItems="filterItems"
        @handleChangePage="handleChangePage"
      />
    </div> -->
  </div>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.js";
import saleApi from "@/api/sale/";

import transactionApi from "@/api/transaction/";
// import transactionNewsApi from "@/api/transaction/";

import whApi from "@/api/warehouse/";
import pdfOrder from "../../components/files/pdfOrder.vue";
// import pdfFile from "../../components/files/invoiceFile.vue";
import pdfFile from "../../components/files/invoiceFileMock.vue";

import DialogConfirmByPass from "../../components/dialogConfirmByPass.vue";
import DialogCancelOrder from "../components/dialogCancelOrder.vue";
import Pagination from "../../components/pagination.vue";
import Loader from "../../components/loaderIndex.vue";
import locale from "ant-design-vue/es/date-picker/locale/th_TH";
import moment from "moment";
import dayjs, { Dayjs } from "dayjs";
// import moment from "moment";

import userApi from "@/api/user/";
import { Decode } from "@/services";

export default {
  components: {
    DialogConfirmByPass,
    DialogCancelOrder,
    Pagination,
    Loader,
    pdfOrder,
    pdfFile,
  },
  setup() {
    document.title = "BELUCA | สรุปขายปลีกประจำวัน";
    return {
      locale,
    };
  },
  data: () => ({
    // dateSelected: moment(new Date()),
    dateSelected: dayjs(),
    selectStatus: "",
    date_from: "",
    date_to: "",

    isExportOrder: false,
    isExportReceive: false,
    date_from: "",
    date_to: "",
    json_fields: {
      buyercode: {
        field: "customer",
        callback: (value) => {
          return `${value.code ? value.code : ""} `;
        },
      },
      buyername: {
        field: "customer",
        callback: (value) => {
          return `${value.name ? value.name : ""} `;
        },
      },

      date: {
        field: "date",
        callback: (value) => {
          return `${moment(value.createdAt).format("DD/MM/YYYY ")}`;
        },
      },
      discouts: "discount",
      payby: "payment_by",
      net: "total_price_summary",
      cash: "cash",
      status: "status",
    },
    columns: [
      { title: "", dataIndex: "checkbox", width: 50, fixed: "left" },
      {
        title: "documentnumber",
        dataIndex: "point_of_sale_no",
        width: 80,
        // fixed: "left",
      },
      {
        title: "transaction_number",
        dataIndex: "transaction_number",
        width: 200,
      },
      { title: "invoice_number", dataIndex: "invoice_number", width: 200 },
      { title: "buyercode", dataIndex: "customer.code", width: 120 },
      { title: "buyername", dataIndex: "customer.name", width: 180 },
      { title: "date", dataIndex: "createdAt", width: 120 },
      { title: "discouts", dataIndex: "discount", width: 120 },
      { title: "payby", dataIndex: "payment_by", width: 120 },
      { title: "net", dataIndex: "total_price_summary", width: 120 },
      { title: "cash", dataIndex: "cash", width: 120 },
      { title: "van", dataIndex: "van", width: 120 },
      { title: "status", dataIndex: "status", width: 160, fixed: "right" },
      { title: "reprint", dataIndex: "reprint", width: 100, fixed: "right" },
    ],

    loading: false,
    loadingUpdate: false,
    dataItemsShow: [],
    showing1: null,

    dialogConfirmByPass: false,
    dialogCancelOrder: false,

    date: dayjs(new Date()),

    total: "",
    tableItems: [],
    itemApprove: {},

    hoverA: false,
    hoverB: false,

    searchInput: "",
    dateSearch: "",
    allData: [],
    userAuth: [],
    userLocal: [],
    masterMenuId: 18,
    vans: [],
    vanSelected: "",
    dataExport: [],
  }),

  created() {
    // this.search();
    this.checkMenu();
    this.getAll();
    this.getAllVans();
  },
  watch: {
    vanSelected(val) {
      console.log("vanSelected", val);
    },
  },

  methods: {
    async getAllVans() {
      this.loading = true;
      let responseData = [];
      try {
        responseData = await whApi.van.getAll(localStorage.getItem("branchId"));
      } catch (error) {
        console.log(error);
      }
      if (responseData.response_status === "SUCCESS") {
        this.vans = responseData.data;
      } else {
        this.loading = false;
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ดึงข้อมูลไม่สำเร็จ กรุณาตรวจสอบ SERVER",
        });
      }
    },
    async checkboxprint() {
      Swal.fire({
        icon: "question",
        title: `กรุณาเลือกประเภทเอกสาร`,
        confirmButtonText: `พิมพ์ต้นฉบับ`,
        cancelButtonText: `พิมพ์สำเนา`,
        showCancelButton: true,
        showConfirmButton: true,
        showCloseButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#50CD89",
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.dataExport = [];
          let checked = [];
          checked = this.dataItemsShow.filter((filter) => filter.check == true);
          // แผ่นเดียว

          checked.forEach((element) => {
            let routeData = this.$router.resolve({
              name: "authentication-general-PDF",
              query: {
                id: element.id,
                isCopy: false,
              },
            });
            element.isCopy = false;
            window.open(routeData.href, "_blank");
          });
        } else if (result.isDismissed) {
          this.dataExport = [];
          let checked = [];
          checked = this.dataItemsShow.filter((filter) => filter.check == true);
          // แผ่นเดียว

          checked.forEach((element) => {
            element.isCopy = true;
            let routeData = this.$router.resolve({
              name: "authentication-general-PDF",
              query: {
                id: element.id,
                isCopy: true,
              },
            });
            window.open(routeData.href, "_blank");
          });
        }
      });

      // หลายแผ่น
      // checked.forEach(async (element) => {
      //   let result = await transactionApi.transaction.getOne(element.id);
      //   this.dataExport.push(result.data);
      //   this.isExportReceive = true;
      //   this.loadingExport = true;
      // });

      console.log("this.dataExport", this.dataExport);
    },
    async checkMenu() {
      this.userLocal = JSON.parse(
        Decode.decode(localStorage.getItem("user_temp"))
      );

      console.log("this.userLocal", this.userLocal);

      let responseData = [];
      try {
        responseData = await userApi.user.checkAuth(
          this.userLocal.userGroupId,
          this.masterMenuId
        );
      } catch (error) {
        console.log(error);
      }
      if (responseData.response_status === "SUCCESS") {
        this.userAuth = responseData.data[0];
        console.log("userAuth", this.userAuth);
        if (!this.userAuth.isCanView) {
          // Swal.fire({
          //   icon: "error",
          //   title: "ไม่มีสิทธิ์เข้าใช้งาน",
          //   text: "ดึงข้อมูลไม่สำเร็จ กรุณาตรวจสอบ SERVER",
          // });
          this.$router.push("/404");
        }
      } else {
      }
    },
    convertDate(date) {
      return moment(date).format("DD-MM-YYYY HH:mm");
    },
    async changeStatus(item) {
      Swal.fire({
        icon: "question",
        title: `${this.$t("confirm")} ${this.$t("ornot")} ?`,
        confirmButtonText: `${this.$t("ok")} `,
        cancelButtonText: `${this.$t("cancel")} `,
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.loading = true;
          let responseData = [];
          let data = { ...item, payment_by: "CASH VAN" };
          // console.log("data", data);
          try {
            responseData = await transactionApi.transaction.update(
              item.id,
              data
            );
          } catch (error) {
            console.log(error);
          }
          console.log({ responseData });
          if (responseData.response_status === "SUCCESS") {
            this.getAll();
          } else {
            this.loading = false;
            Swal.fire({
              icon: "error",
              title: "เกิดข้อผิดพลาด",
              text: "ดึงข้อมูลไม่สำเร็จ กรุณาตรวจสอบ SERVER",
            });
          }
        } else {
          return (item.status = "ชำระเงินแล้ว");
        }
      });
    },
    async getAll() {
      this.loading = true;
      let responseData = [];
      // let companyId = localStorage.getItem("companyId");
      try {
        responseData = await transactionApi.transaction.getAll(
          "CASH VAN",
          localStorage.getItem("companyId"),
          localStorage.getItem("branchId")
        );
      } catch (error) {
        console.log(error);
      }
      console.log({ responseData });
      if (responseData.response_status === "SUCCESS") {
        this.dataItemsShow = responseData.data;
        this.dataItemsShow.forEach((element, index) => {
          element.no = index + 1;
        });
        this.tableItems = responseData.data;
        this.loading = false;
        this.sumTotal(this.dataItemsShow);
      } else {
        this.loading = false;
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ดึงข้อมูลไม่สำเร็จ กรุณาตรวจสอบ SERVER",
        });
      }
    },

    sumTotal(items) {
      let sum = items.reduce(
        (sum, data) => sum + parseFloat(data.total_price_summary),
        0
      );
      sum = sum.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
      this.total = sum;
    },

    //--- Pagination --- start
    filterItems(val) {
      this.dataItemsShow = val;
    },

    handleChangePage(val, showing1) {
      this.dataItemsShow = val;
      this.showing1 = showing1;
    },
    //exportfile

    async goToExportOrder(item, index) {
      // console.log("itemexport", item);
      this.loading = true;

      let responseData = [];
      try {
        responseData = await transactionApi.transaction.getOne(item.id);
      } catch (error) {
        console.log(error);
      }
      if (responseData.response_status === "SUCCESS") {
        let result = responseData.data;
        console.log("result", result);
        /////////
        this.dataExport = result;

        // this.dataExport.products;
        this.indexExport = index;
        this.loadingExport = true;
        this.isExportOrder = true;
        this.loadingExport = true;
        this.isExportOrder = true;
        setTimeout(() => {
          this.loadingExport = false;
          this.isExportOrder = false;
        }, 1500);
      }
      this.loading = false;
    },
    async goToExportReceive(item, index) {
      Swal.fire({
        icon: "question",
        title: `กรุณาเลือกประเภทเอกสาร`,
        confirmButtonText: `พิมพ์ต้นฉบับ`,
        cancelButtonText: `พิมพ์สำเนา`,
        showCancelButton: true,
        showConfirmButton: true,
        showCloseButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#50CD89",
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.loading = true;
          let responseData = [];
          try {
            responseData = await transactionApi.transaction.getOne(item.id);
          } catch (error) {
            console.log(error);
          }
          if (responseData.response_status === "SUCCESS") {
            let result = responseData.data;
            console.log("resultaaaaa", result);
            /////////
            this.dataExport = result;
            // this.dataExport.products.forEach((element) => {
            //   this.dataExport.sumDiscountModel += element.discountAmtValue;
            // });
            this.dataExport.sumDiscountModel = result.discount;
            this.indexExport = index;
            this.dataExport.isCopy = false;
            this.loadingExport = true;
            this.isExportReceive = true;
            setTimeout(() => {
              this.loadingExport = false;
              this.isExportReceive = false;
            }, 1500);
          }
          this.loading = false;
        } else if (result.isDismissed) {
          let responseData = [];
          try {
            responseData = await transactionApi.transaction.getOne(item.id);
          } catch (error) {
            console.log(error);
          }
          if (responseData.response_status === "SUCCESS") {
            let result = responseData.data;
            console.log("result", result);
            /////////
            this.dataExport = result;
            this.dataExport.sumDiscountModel = result.discount;
            this.indexExport = index;
            this.dataExport.isCopy = true;
            this.loadingExport = true;
            this.isExportReceive = true;
            setTimeout(() => {
              this.loadingExport = false;
              this.isExportReceive = false;
            }, 1500);
          }
          this.loading = false;
        }
      });
      // console.log("itemexport", item);
    },
    //--- Pagination --- end

    goToNew() {
      this.$router.push("/sale/SA2-1/new");
    },
    goToEdit(id) {
      let routeData = this.$router.resolve({
        name: "sale-daily-retail-summary-cashvan-edit",
        query: {
          id: id,
        },
      });
      window.open(routeData.href, "_blank");
      // this.$router.push({
      //   name: "CUSTOMER-list-route",
      //   query: {
      //     id: id,
      //   },
      // });
    },
    goToDelete() {},

    handleHoverA() {
      this.hoverA = true;
      this.hoverB = false;
    },
    handleHoverB() {
      this.hoverB = true;
      this.hoverA = false;
    },
    generatedFile() {
      this.isExport = false;
    },

    handleApprove() {
      this.dialogConfirmByPass = true;
    },

    handleCancelOrder(item) {
      this.itemApprove = { ...item };
      this.dialogCancelOrder = true;
    },

    submitConfirmPass() {
      this.isApprove = true;
      this.dialogConfirmByPass = false;
    },
    closeDialogConformByPass() {
      this.isApprove = false;
      this.dialogConfirmByPass = false;
    },

    submitCancelOrder(isApprove) {
      this.statusApprove(isApprove, "cancel");
      this.dialogCancelOrder = false;
    },

    closeDialogCancelOrder() {
      this.dialogCancelOrder = false;
    },

    formatDate(date) {
      const newDate = moment(date.substring(0, 10)).format("DD/MM/YYYY");
      const newTime = moment(date).format("LTS");
      if (date) {
        const oldDate = `${newDate} - ${newTime}`;

        return oldDate;
      } else {
        return "-";
      }
    },

    async statusApprove(isApprove, method) {
      let updateResponse = [];
      // const id = this.itemApprove.id;

      // this.itemApprove = {
      //   ...this.itemApprove,
      //   status: isApprove ? 1 : 2,
      //   is_cancel: method === "cancel" ? "1" : "0",
      // };

      // updateResponse = await saleApi.pos.delete(id, this.itemApprove);

      // console.log(this.itemApprove);
      updateResponse = await transactionApi.transaction.delete(id);
      if (updateResponse.response_status === "SUCCESS") {
        if (isApprove) {
          // this.updateProduct();
          Swal.fire({
            icon: `${method === "cancel" ? "error" : "success"}`,
            title: `${
              method === "cancel" ? "ยกเลิกรายการสำเร็จ" : "อนุมัติสำเร็จ"
            }`,
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            this.loadingUpdate = false;
            // this.search();
          });
        } else {
          Swal.fire({
            icon: "error",
            title: `ไม่อนุมัติ`,
            showConfirmButton: false,
            timer: 1500,
          });
        }
        this.loadingUpdate = false;
        // this.search();
      } else {
        Swal.fire({
          icon: "warning",
          title: "อนุมัติไม่สำเร็จ !",
          showConfirmButton: false,
          timer: 1500,
        });
        this.loadingUpdate = false;
      }
    },

    // update item
    async updateProduct() {
      let countArr = 0;
      for (const element of this.itemApprove.pointOfSaleItems) {
        countArr += 1;
        await this.getOneProduct(element.product.id, element.item_amt);
      }
      // if (
      //   countArr === this.form.products.length &&
      //   this.statusAllProcess === 1
      // ) {
      //   this.$router.push({
      //     path: "/sale/SA5",
      //     query: {},
      //   });
      // }
    },
    async getOneProduct(id, item_amt) {
      let getOneResponse = {};
      try {
        getOneResponse = await whApi.product.getOne(id);
      } catch (error) {
        console.log(error);
      }
      if (getOneResponse.response_status === "SUCCESS") {
        this.updateProductAmountRecieve(item_amt, getOneResponse.data);
      }
    },
    async updateProductAmountRecieve(item_amt, item) {
      let updateResponse = [];
      let sumQty = parseFloat(item.product_bring_qty) + parseFloat(item_amt);

      const body = {
        ...item,
        product_bring_qty: sumQty,
      };

      updateResponse = await whApi.product.update(item.id, body);
      if (updateResponse.response_status !== "SUCCESS") {
        this.statusAllProcess *= 0;

        Swal.fire({
          icon: "error",
          html: `ชำระค่าสินค้าไม่สำเร็จ !`,
          timer: 4000,
        });
      } else {
        this.statusAllProcess *= 1;
      }
    },
    // update item

    setDateThLocale(dateVal) {
      moment.locale("th");
      return moment(dateVal).format("DD/MM/YYYY - HH:mm:ss น.");
    },

    // async search() {
    //   const newDate = this.date
    //     ? moment(this.date.$d).format("YYYY-MM-DD")
    //     : "";

    //   this.loading = true;

    //   const responseSearch = await transactionApi.transaction.search({
    //     search: this.searchInput,
    //     // date: newDate,
    //     date_from: moment(this.date_from.$d).format("YYYY-MM-DD"),
    //     date_to: moment(this.date_to.$d).format("YYYY-MM-DD"),
    //     companyId: localStorage.getItem("companyId"),
    //   });

    //   if (responseSearch.response_status === "SUCCESS") {
    //     this.dataItemsShow = responseSearch.data;
    //     this.dataItemsShow.forEach((element, index) => {
    //       element.no = index + 1;
    //     });
    //     this.tableItems = responseSearch.data;
    //     this.allData = responseSearch.data;
    //     this.loading = false;
    //     this.sumTotal(this.dataItemsShow);
    //   }
    // },
    async search() {
      const newDate = this.dateSelected
        ? moment(this.dateSelected.$d).format("YYYY-MM-DD")
        : "";

      this.loading = true;

      const responseSearch = await transactionApi.transaction.search({
        search: this.searchInput,
        date: newDate,
        companyId: localStorage.getItem("companyId"),
        branchId: localStorage.getItem("branchId"),
        status: this.selectStatus,
        vanId: this.vanSelected.id,
        payment_by: "CASH VAN",
      });

      if (responseSearch.response_status === "SUCCESS") {
        this.dataItemsShow = responseSearch.data;
        this.dataItemsShow.forEach((element, index) => {
          element.no = index + 1;
        });
        this.tableItems = responseSearch.data;
        this.allData = responseSearch.data;
        this.loading = false;
        this.sumTotal(this.dataItemsShow);
      }
    },
    clear() {
      this.dateSelected = dayjs();
      (this.vanSelected = ""), (this.searchInput = "");
      this.selectStatus = "";
      this.getAll();
    },
  },
};
</script>
<style scoped src="@/assets/custom-outside.css"></style>
